import { Injectable } from '@angular/core';
import { ADOPTION_QUIZZES, AdoptionQuiz } from '../components/dialogs/adoption-modal/adoption-quiz.model';

const STORAGE_KEY = 'al-adoptionQuizzes-v1';

/** Tracks which Adoption-Quizzes a user has already solved, so the modal
 *  never repeats one. Frontend-only (localStorage) for now, mirroring the
 *  chat-widget onboarding-tour persistence pattern. */
@Injectable({ providedIn: 'root' })
export class AdoptionService {
  /** Das Routing hat ZWEI DashboardLayout-Instanzen ('' und 'admin') —
   *  beim Wechsel zwischen normalen und Admin-Seiten wird das Layout neu
   *  gemountet und ngOnInit feuert erneut. Dieses Flag stellt sicher,
   *  dass pro App-Load (= Login bzw. Seiten-Reload) höchstens ein Quiz
   *  ausgespielt wird, egal wie oft das Layout mountet. */
  private shownThisSession = false;

  private getSeen(): Set<string> {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return new Set(raw ? (JSON.parse(raw) as string[]) : []);
    } catch {
      return new Set();
    }
  }

  private saveSeen(seen: Set<string>): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen]));
  }

  /** First quiz not yet solved, or null once all are done — or once a
   *  quiz was already claimed this app load. Claim-Semantik: der erste
   *  Aufrufer, der ein Quiz zurückbekommt, verbraucht den Session-Slot. */
  getNextUnseenQuiz(): AdoptionQuiz | null {
    if (this.shownThisSession) {
      return null;
    }
    const seen = this.getSeen();
    const quiz = ADOPTION_QUIZZES.find((q) => !seen.has(q.slug)) ?? null;
    if (quiz) {
      this.shownThisSession = true;
    }
    return quiz;
  }

  markSeen(slug: string): void {
    const seen = this.getSeen();
    seen.add(slug);
    this.saveSeen(seen);
  }
}
